const EventTypes = Object.freeze({
	PURCHASE_INITIATED: "purchase_initiated",
	PURCHASE_SUCCEEDED: "purchase_succeeded",
	PURCHASE_FAILED: "purchase_failed",
	PAYMENT_RECEIVED: "payment_received",
	TRANSFER_PENDING: "transfer_pending"
})

export default EventTypes;